import { render, staticRenderFns } from "./limitsView.vue?vue&type=template&id=c0f447fa&scoped=true&"
import script from "./limitsView.vue?vue&type=script&lang=js&"
export * from "./limitsView.vue?vue&type=script&lang=js&"
import style0 from "./limitsView.vue?vue&type=style&index=0&id=c0f447fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f447fa",
  null
  
)

export default component.exports